import { PORTAL_ROUTE_PREFIX, ERROR_MESSAGE_NOT_LOGGED_IN, } from '../../constants/values';
import { getIdentityUrl } from '../../utils/identity_helper';
var redirectIfNotLoggedIn = function (storeAPI) { return function (next) { return function (action) {
    if (!action) {
        return next(action);
    }
    var actionType = (action && action.type) || '';
    var payloadError = (action.payload && action.payload.error) || '';
    // We only want to redirect user when a promise is rejected other than FETCH_BOOTSTRAP_DATA
    // FETCH_BOOTSTRAP_DATA rejection is handled elsewhere, as it is part of the "only allow logged in user" logic
    var shouldRedirect = actionType.endsWith('_REJECTED') &&
        !actionType.startsWith('FETCH_BOOTSTRAP_DATA') &&
        payloadError === ERROR_MESSAGE_NOT_LOGGED_IN;
    if (!shouldRedirect) {
        return next(action);
    }
    window.location.href = getIdentityUrl({
        nextPath: PORTAL_ROUTE_PREFIX,
    });
    return;
}; }; };
export default redirectIfNotLoggedIn;
